import { API } from "aws-amplify";

/**
 * Normalize a facility record from /corporates/facilities/userFacilities.
 */
export function normalizeCorporateFacility(raw) {
  if (!raw) return null;
  const id = raw._id ?? raw.id ?? raw.FacilityId;
  if (!id) return null;
  return {
    _id: String(id),
    Name: raw.Name ?? raw.name ?? raw.FacilityName ?? String(id),
    TimeZone:
      raw.TimeZone ??
      raw.FacilityTimeZone ??
      raw.timezone ??
      raw.facilityTimeZone ??
      null,
  };
}

/**
 * Fetch facilities for the logged-in corporate user.
 * @returns {Promise<{ success: boolean, facilities: Array, error?: string }>}
 */
export async function fetchCorporateFacilities() {
  try {
    const response = await API.get("lambda", "/corporates/facilities/userFacilities");
    const content = response?.Content ?? response?.data?.Content ?? response;
    const rawList =
      content?.userFacilities ??
      content?.facilities ??
      content?.Facilities ??
      (Array.isArray(content) ? content : []);

    const facilities = (Array.isArray(rawList) ? rawList : [])
      .map(normalizeCorporateFacility)
      .filter(Boolean);

    return { success: true, facilities };
  } catch (error) {
    console.error("Error fetching corporate facilities:", error);
    return {
      success: false,
      facilities: [],
      error: error?.message ?? "Failed to load communities",
    };
  }
}
